/**
 * Customer Portal (UI) - shared confirmation modal for destructive Webhooks actions.
 */
type ConfirmDeleteModalProps = {
  isOpen: boolean;
  title: string;
  message: string;
  confirmLabel: string;
  confirming: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

export function ConfirmDeleteModal({
  isOpen,
  title,
  message,
  confirmLabel,
  confirming,
  onCancel,
  onConfirm
}: ConfirmDeleteModalProps) {
  if (!isOpen) {
    return null;
  }

  return (
    <div className="modal modal-blur fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.3)' }} role="dialog" aria-modal="true">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{title}</h5>
            <button type="button" className="btn-close" aria-label="Close" onClick={onCancel} disabled={confirming} />
          </div>
          <div className="modal-body">
            <p className="mb-0 text-secondary">{message}</p>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-link link-secondary" onClick={onCancel} disabled={confirming}>
              Cancel
            </button>
            <button type="button" className="btn btn-danger ms-auto" onClick={onConfirm} disabled={confirming}>
              {confirming ? 'Deleting...' : confirmLabel}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
